import { RestVialStatus } from '../../database/schema.js';
/** A QA reject may only discard a rest vial the rejected preparation created that no other preparation has taken (CY-329). */
export function isSpoilableRestVial(restVial, sequenceId) {
    return (restVial.status === RestVialStatus.enum.AVAILABLE && restVial.deletedAt == null && restVial.sequenceId === sequenceId);
}
/** Returns the ticked rest vials to discard; refuses the whole reject if any of them is no longer spoilable. */
export function pickRestVialsToSpoil(restVials, sequenceId, selectedIds) {
    return [...new Set(selectedIds)].map(id => {
        const restVial = restVials.find(r => r.id === id);
        if (!restVial)
            throw new Error(`Rest vial ${id} was not found; nothing was rejected.`);
        if (!isSpoilableRestVial(restVial, sequenceId)) {
            throw new Error(`Rest vial #${restVial.internalId ?? restVial.id} is no longer available to discard; nothing was rejected.`);
        }
        return restVial;
    });
}
//# sourceMappingURL=spoilage-rest-vials.js.map